module.exports = __webpack_public_path__ + "img/public/SiteIcons/bookYourIcon.svg?8d1ab2a3";